// Imports: local files.
import ApiClient from '../../services/ApiClient';
import { showSnackbar, dispatchLoading, dispatchSuccess, dispatchError, getAxiosError } from '../../utils/redux';

// Name of property to be used in reducer data.
const analyticsOverviewName = 'overview';
const analyticsRealtimeName = 'realtime';
const analyticsUsersLifetimeName = 'usersLifetime';
const analyticsUsersByDayName = 'usersByDay';
const analyticsUsersSummaryName = 'usersSummary';
const analyticsRealtimeSummaryName = 'realtimeSummary';
const analyticsEventsName = 'events';

// Action Types: Get Analytics Overview
export const GET_ANALYTICS_OVERVIEW_START = 'GET_ANALYTICS_OVERVIEW_START';
export const GET_ANALYTICS_OVERVIEW_SUCCESS = 'GET_ANALYTICS_OVERVIEW_SUCCESS';
export const GET_ANALYTICS_OVERVIEW_FAILED = 'GET_ANALYTICS_OVERVIEW_FAILED';
export const GET_ANALYTICS_OVERVIEW_RESET = 'GET_ANALYTICS_OVERVIEW_RESET';

// Action Types: Get Analytics Realtime
export const GET_ANALYTICS_REALTIME_START = 'GET_ANALYTICS_REALTIME_START';
export const GET_ANALYTICS_REALTIME_SUCCESS = 'GET_ANALYTICS_REALTIME_SUCCESS';
export const GET_ANALYTICS_REALTIME_FAILED = 'GET_ANALYTICS_REALTIME_FAILED';
export const GET_ANALYTICS_REALTIME_RESET = 'GET_ANALYTICS_REALTIME_RESET';

// Action Types: Get Analytics Users Lifetime
export const GET_ANALYTICS_USERS_LIFETIME_START = 'GET_ANALYTICS_USERS_LIFETIME_START';
export const GET_ANALYTICS_USERS_LIFETIME_SUCCESS = 'GET_ANALYTICS_USERS_LIFETIME_SUCCESS';
export const GET_ANALYTICS_USERS_LIFETIME_FAILED = 'GET_ANALYTICS_USERS_LIFETIME_FAILED';
export const GET_ANALYTICS_USERS_LIFETIME_RESET = 'GET_ANALYTICS_USERS_LIFETIME_RESET';

// Action Types: Get Analytics Users By Day
export const GET_ANALYTICS_USERS_BY_DAY_START = 'GET_ANALYTICS_USERS_BY_DAY_START';
export const GET_ANALYTICS_USERS_BY_DAY_SUCCESS = 'GET_ANALYTICS_USERS_BY_DAY_SUCCESS';
export const GET_ANALYTICS_USERS_BY_DAY_FAILED = 'GET_ANALYTICS_USERS_BY_DAY_FAILED';
export const GET_ANALYTICS_USERS_BY_DAY_RESET = 'GET_ANALYTICS_USERS_BY_DAY_RESET';

// Action Types: Get Analytics Users Summary
export const GET_ANALYTICS_USERS_SUMMARY_START = 'GET_ANALYTICS_USERS_SUMMARY_START';
export const GET_ANALYTICS_USERS_SUMMARY_SUCCESS = 'GET_ANALYTICS_USERS_SUMMARY_SUCCESS';
export const GET_ANALYTICS_USERS_SUMMARY_FAILED = 'GET_ANALYTICS_USERS_SUMMARY_FAILED';
export const GET_ANALYTICS_USERS_SUMMARY_RESET = 'GET_ANALYTICS_USERS_SUMMARY_RESET';

// Action Types: Get Analytics Realtime Summary
export const GET_ANALYTICS_REALTIME_SUMMARY_START = 'GET_ANALYTICS_REALTIME_SUMMARY_START';
export const GET_ANALYTICS_REALTIME_SUMMARY_SUCCESS = 'GET_ANALYTICS_REALTIME_SUMMARY_SUCCESS';
export const GET_ANALYTICS_REALTIME_SUMMARY_FAILED = 'GET_ANALYTICS_REALTIME_SUMMARY_FAILED';
export const GET_ANALYTICS_REALTIME_SUMMARY_RESET = 'GET_ANALYTICS_REALTIME_SUMMARY_RESET';

// Action Types: Get Analytics Events
export const GET_ANALYTICS_EVENTS_START = 'GET_ANALYTICS_EVENTS_START';
export const GET_ANALYTICS_EVENTS_SUCCESS = 'GET_ANALYTICS_EVENTS_SUCCESS';
export const GET_ANALYTICS_EVENTS_FAILED = 'GET_ANALYTICS_EVENTS_FAILED';
export const GET_ANALYTICS_EVENTS_RESET = 'GET_ANALYTICS_EVENTS_RESET';

// Action Creators: Analytics Overview
const getAnalyticsOverviewStart = (payload) => ({ type: GET_ANALYTICS_OVERVIEW_START, payload });
const getAnalyticsOverviewSuccess = (payload) => ({ type: GET_ANALYTICS_OVERVIEW_SUCCESS, payload });
const getAnalyticsOverviewFailed = (payload) => ({ type: GET_ANALYTICS_OVERVIEW_FAILED, payload });
const getAnalyticsOverviewReset = () => ({ type: GET_ANALYTICS_OVERVIEW_RESET });

// Action Creators: Analytics Realtime
const getAnalyticsRealtimeStart = (payload) => ({ type: GET_ANALYTICS_REALTIME_START, payload });
const getAnalyticsRealtimeSuccess = (payload) => ({ type: GET_ANALYTICS_REALTIME_SUCCESS, payload });
const getAnalyticsRealtimeFailed = (payload) => ({ type: GET_ANALYTICS_REALTIME_FAILED, payload });
const getAnalyticsRealtimeReset = () => ({ type: GET_ANALYTICS_REALTIME_RESET });

// Action Creators: Analytics Users Lifetime
const getAnalyticsUsersLifetimeStart = (payload) => ({ type: GET_ANALYTICS_USERS_LIFETIME_START, payload });
const getAnalyticsUsersLifetimeSuccess = (payload) => ({ type: GET_ANALYTICS_USERS_LIFETIME_SUCCESS, payload });
const getAnalyticsUsersLifetimeFailed = (payload) => ({ type: GET_ANALYTICS_USERS_LIFETIME_FAILED, payload });
const getAnalyticsUsersLifetimeReset = () => ({ type: GET_ANALYTICS_USERS_LIFETIME_RESET });

// Action Creators: Analytics Users By Day
const getAnalyticsUsersByDayStart = (payload) => ({ type: GET_ANALYTICS_USERS_BY_DAY_START, payload });
const getAnalyticsUsersByDaySuccess = (payload) => ({ type: GET_ANALYTICS_USERS_BY_DAY_SUCCESS, payload });
const getAnalyticsUsersByDayFailed = (payload) => ({ type: GET_ANALYTICS_USERS_BY_DAY_FAILED, payload });
const getAnalyticsUsersByDayReset = () => ({ type: GET_ANALYTICS_USERS_BY_DAY_RESET });

// Action Creators: Analytics Users Summary
const getAnalyticsUsersSummaryStart = (payload) => ({ type: GET_ANALYTICS_USERS_SUMMARY_START, payload });
const getAnalyticsUsersSummarySuccess = (payload) => ({ type: GET_ANALYTICS_USERS_SUMMARY_SUCCESS, payload });
const getAnalyticsUsersSummaryFailed = (payload) => ({ type: GET_ANALYTICS_USERS_SUMMARY_FAILED, payload });
const getAnalyticsUsersSummaryReset = () => ({ type: GET_ANALYTICS_USERS_SUMMARY_RESET });

// Action Creators: Analytics Realtime Summary
const getAnalyticsRealtimeSummaryStart = (payload) => ({ type: GET_ANALYTICS_REALTIME_SUMMARY_START, payload });
const getAnalyticsRealtimeSummarySuccess = (payload) => ({ type: GET_ANALYTICS_REALTIME_SUMMARY_SUCCESS, payload });
const getAnalyticsRealtimeSummaryFailed = (payload) => ({ type: GET_ANALYTICS_REALTIME_SUMMARY_FAILED, payload });
const getAnalyticsRealtimeSummaryReset = () => ({ type: GET_ANALYTICS_REALTIME_SUMMARY_RESET });

// Action Creators: Analytics Events
const getAnalyticsEventsStart = (payload) => ({ type: GET_ANALYTICS_EVENTS_START, payload });
const getAnalyticsEventsSuccess = (payload) => ({ type: GET_ANALYTICS_EVENTS_SUCCESS, payload });
const getAnalyticsEventsFailed = (payload) => ({ type: GET_ANALYTICS_EVENTS_FAILED, payload });
const getAnalyticsEventsReset = () => ({ type: GET_ANALYTICS_EVENTS_RESET });

// Actions: Get Analytics Overview
export const getAnalyticsOverview = (options = {}) => {
  return async (dispatch) => {
    try {
      dispatchLoading(dispatch, getAnalyticsOverviewStart);

      const result = await ApiClient.get('/analytics/overview');
      if (result.data?.success) {
        const { data } = result.data;
        dispatch(getAnalyticsOverviewSuccess({ 
          loading: false, 
          success: true, 
          data: data, 
          error: false, 
          errorMessage: null 
        }));
      } else {
        const errorMessage = result.data?.error || 'Something went wrong!';
        dispatchError(dispatch, getAnalyticsOverviewFailed, errorMessage);
        showSnackbar(dispatch, errorMessage, 'error');
      }
    } catch (error) {
      const errorMessage = getAxiosError(error);
      dispatchError(dispatch, getAnalyticsOverviewFailed, errorMessage);
      showSnackbar(dispatch, errorMessage, 'error');
    }
  };
};

// Actions: Get Analytics Realtime
export const getAnalyticsRealtime = (options = {}) => {
  const { nocache } = options;
  return async (dispatch) => {
    try {
      dispatchLoading(dispatch, getAnalyticsRealtimeStart);

      const params = nocache ? { nocache: '1' } : {};
      const result = await ApiClient.get('/analytics/realtime', { params });
      if (result.data?.success) {
        const { data } = result.data;
        dispatch(getAnalyticsRealtimeSuccess({ 
          loading: false, 
          success: true, 
          data: data, 
          error: false, 
          errorMessage: null 
        }));
      } else {
        const errorMessage = result.data?.error || 'Something went wrong!';
        dispatchError(dispatch, getAnalyticsRealtimeFailed, errorMessage);
        showSnackbar(dispatch, errorMessage, 'error');
      }
    } catch (error) {
      const errorMessage = getAxiosError(error);
      dispatchError(dispatch, getAnalyticsRealtimeFailed, errorMessage);
      showSnackbar(dispatch, errorMessage, 'error');
    }
  };
};

// Actions: Get Analytics Users Lifetime
export const getAnalyticsUsersLifetime = (options = {}) => {
  return async (dispatch) => {
    try {
      dispatchLoading(dispatch, getAnalyticsUsersLifetimeStart);

      const result = await ApiClient.get('/analytics/users/lifetime');
      if (result.data?.success) {
        const data = result.data;
        dispatch(getAnalyticsUsersLifetimeSuccess({ 
          loading: false, 
          success: true, 
          data: data, 
          error: false, 
          errorMessage: null 
        }));
      } else {
        const errorMessage = result.data?.error || 'Something went wrong!';
        dispatchError(dispatch, getAnalyticsUsersLifetimeFailed, errorMessage);
        showSnackbar(dispatch, errorMessage, 'error');
      }
    } catch (error) {
      const errorMessage = getAxiosError(error);
      dispatchError(dispatch, getAnalyticsUsersLifetimeFailed, errorMessage);
      showSnackbar(dispatch, errorMessage, 'error');
    }
  };
};

// Actions: Get Analytics Users By Day
export const getAnalyticsUsersByDay = (payload = {}, options = {}) => {
  const { start = '90daysAgo', end = 'today' } = payload;
  return async (dispatch) => {
    try {
      dispatchLoading(dispatch, getAnalyticsUsersByDayStart);

      const params = { start, end };
      const result = await ApiClient.get('/analytics/users/by-day', { params });
      if (result.data?.success) {
        const data = result.data;
        dispatch(getAnalyticsUsersByDaySuccess({ 
          loading: false, 
          success: true, 
          data: data, 
          error: false, 
          errorMessage: null 
        }));
      } else {
        const errorMessage = result.data?.error || 'Something went wrong!';
        dispatchError(dispatch, getAnalyticsUsersByDayFailed, errorMessage);
        showSnackbar(dispatch, errorMessage, 'error');
      }
    } catch (error) {
      const errorMessage = getAxiosError(error);
      dispatchError(dispatch, getAnalyticsUsersByDayFailed, errorMessage);
      showSnackbar(dispatch, errorMessage, 'error');
    }
  };
};

// Actions: Get Analytics Users Summary
export const getAnalyticsUsersSummary = (options = {}) => {
  return async (dispatch) => {
    try {
      dispatchLoading(dispatch, getAnalyticsUsersSummaryStart);

      const result = await ApiClient.get('/analytics/users/summary');
      if (result.data?.success) {
        const data = result.data;
        dispatch(getAnalyticsUsersSummarySuccess({ 
          loading: false, 
          success: true, 
          data: data, 
          error: false, 
          errorMessage: null 
        }));
      } else {
        const errorMessage = result.data?.error || 'Something went wrong!';
        dispatchError(dispatch, getAnalyticsUsersSummaryFailed, errorMessage);
        showSnackbar(dispatch, errorMessage, 'error');
      }
    } catch (error) {
      const errorMessage = getAxiosError(error);
      dispatchError(dispatch, getAnalyticsUsersSummaryFailed, errorMessage);
      showSnackbar(dispatch, errorMessage, 'error');
    }
  };
};

// Actions: Get Analytics Realtime Summary
export const getAnalyticsRealtimeSummary = (options = {}) => {
  return async (dispatch) => {
    try {
      dispatchLoading(dispatch, getAnalyticsRealtimeSummaryStart);

      const result = await ApiClient.get('/analytics/realtime/summary');
      if (result.data?.success) {
        const data = result.data;
        dispatch(getAnalyticsRealtimeSummarySuccess({ 
          loading: false, 
          success: true, 
          data: data, 
          error: false, 
          errorMessage: null 
        }));
      } else {
        const errorMessage = result.data?.error || 'Something went wrong!';
        dispatchError(dispatch, getAnalyticsRealtimeSummaryFailed, errorMessage);
        showSnackbar(dispatch, errorMessage, 'error');
      }
    } catch (error) {
      const errorMessage = getAxiosError(error);
      dispatchError(dispatch, getAnalyticsRealtimeSummaryFailed, errorMessage);
      showSnackbar(dispatch, errorMessage, 'error');
    }
  };
};

// Actions: Get Analytics Events
export const getAnalyticsEvents = (payload = {}, options = {}) => {
  const { name = 'session_start' } = payload;
  return async (dispatch) => {
    try {
      dispatchLoading(dispatch, getAnalyticsEventsStart);

      const params = { name };
      const result = await ApiClient.get('/analytics/events', { params });
      if (result.data?.success) {
        const { data } = result.data;
        dispatch(getAnalyticsEventsSuccess({ 
          loading: false, 
          success: true, 
          data: data, 
          error: false, 
          errorMessage: null 
        }));
      } else {
        const errorMessage = result.data?.error || 'Something went wrong!';
        dispatchError(dispatch, getAnalyticsEventsFailed, errorMessage);
        showSnackbar(dispatch, errorMessage, 'error');
      }
    } catch (error) {
      const errorMessage = getAxiosError(error);
      dispatchError(dispatch, getAnalyticsEventsFailed, errorMessage);
      showSnackbar(dispatch, errorMessage, 'error');
    }
  };
};

// Actions: Clear Analytics Overview
export const clearAnalyticsOverview = () => getAnalyticsOverviewReset();

// Actions: Clear Analytics Realtime
export const clearAnalyticsRealtime = () => getAnalyticsRealtimeReset();

// Actions: Clear Analytics Users Lifetime
export const clearAnalyticsUsersLifetime = () => getAnalyticsUsersLifetimeReset();

// Actions: Clear Analytics Users By Day
export const clearAnalyticsUsersByDay = () => getAnalyticsUsersByDayReset();

// Actions: Clear Analytics Users Summary
export const clearAnalyticsUsersSummary = () => getAnalyticsUsersSummaryReset();

// Actions: Clear Analytics Realtime Summary
export const clearAnalyticsRealtimeSummary = () => getAnalyticsRealtimeSummaryReset();

// Actions: Clear Analytics Events
export const clearAnalyticsEvents = () => getAnalyticsEventsReset();